'use strict';
var angular = require('angular');
var QuickOrderService = /** @class */ (function () {
    function QuickOrderService($http, Util, $log, $cookies, Auth, $q) {
        'ngInject';
        this._$http = $http;
        this.$log = $log;
        this.$cookies = $cookies;
        this.Auth = Auth;
        this.handleError = Util.handleError;
    }
    QuickOrderService.prototype.getItemDetail = function (itemCode) {
        var self = this;
        return this._$http.get('api/products/quickOrder/' + itemCode)
            .then(function success(response) {
            return response.data.response;
        }, function error(response) {
            self.$log.error('error response.....', response);
        });
    };
    return QuickOrderService;
}());
export default QuickOrderService;
//# sourceMappingURL=quick-order.service.js.map